import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormProvider } from 'react-hook-form';
import ArticleBasic from './ArticleBasic';
import ArticleHeader from './ArticleHeader';
import ArticleUpload from './ArticleUpload';
import ArticleFooter from './ArticleFooter';
import ArticleRefe from './ArticleRefe';
// import Taxes from './Taxes';
// import ArticleStock from './ArticleStock';
import ArticleSpecifications from './ArticleSpecifications';
import { useNewArticle } from '../useArticleHooks';
import ArticleReferences from './ArticleReferences';
import ArticleMeasuring from './ArticleMeasuring';
import ArticleQuantities from './ArticleQuantities';

const AddArticle = () => {
 const { methods, onSubmit, handleSubmit, onError } = useNewArticle();

 return (
  <FormProvider {...methods}>
   <Form onSubmit={handleSubmit(onSubmit, onError)}>
    <Row className="g-3">
     <Col xs={12}>
      <ArticleHeader />
     </Col>
     <Col lg={8}>
      <ArticleBasic />
      <ArticleUpload />
      <ArticleSpecifications />
      <ArticleReferences />
     </Col>
     <Col lg={4}>
      <div className="sticky-sidebar">
       <ArticleMeasuring />
       <ArticleQuantities />
       <ArticleRefe />
      </div>
     </Col>
     <Col>
      <ArticleFooter />
     </Col>
    </Row>
   </Form>
  </FormProvider>
 );
};

export default AddArticle;
